import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import "./Programs.css";

const programs = [
  {
    icon: "handCoins",
    title: "Financial Support",
    description:
      "Most financial programs require a NICU stay of at least 30 days before they assist. We bridge that gap with subsidies for the everyday costs that add up fast during a hospital stay.",
    highlights: [
      "Parking and transportation subsidies",
      "Meal assistance for caregivers",
      "Help with unexpected, out-of-pocket costs",
      "Available regardless of length of stay"
    ]
  },
  {
    icon: "package",
    title: "Preemie Care Packages",
    description:
      "Hospital clothes are oversized and scratchy, and harsh soaps damage delicate skin. Our care packages are built for baby and caregiver alike, with the essentials that actually fit NICU life.",
    highlights: [
      "Preemie-sized clothing and blankets",
      "Bottles, pacifiers, and formula",
      "Gentle skincare for baby and caregiver",
      "Comfort items for long hospital days"
    ]
  },
  {
    icon: "clipboard",
    title: "Social Program Assistance",
    description:
      "Programs like WIC and Medicaid can be difficult to navigate, and even harder while caring for your little bug. We help with the paperwork so you can focus on your baby.",
    highlights: [
      "Guidance applying for WIC and Medicaid",
      "Help gathering and submitting documents",
      "Support tracking deadlines and renewals",
      "One-on-one help from people who've been there"
    ]
  },
  {
    icon: "smartphone",
    title: "LilyPad",
    comingSoon: true,
    description:
      "Coming soon: one-touch access to request care packages, get help with paperwork, and apply for financial assistance, right from your baby's bedside.",
    highlights: [
      "Request a care package in seconds",
      "Track paperwork and applications",
      "Apply for financial assistance",
      "Replace breast pump parts easily"
    ]
  }
];

export default function Programs() {
  return (
    <div className="programs-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Programs</h1>
          <p>Practical, hands-on support for NICU and PICU families, built by parents who've lived it.</p>
        </div>
      </section>

      <section>
        <div className="container programs-list">
          {programs.map((program) => (
            <article className="program-card" key={program.title}>
              <div className="program-text">
                <span className="program-icon">
                  <Icon name={program.icon} />
                </span>
                <h2>
                  {program.title}
                  {program.comingSoon && <span className="program-badge">Coming soon</span>}
                </h2>
                <p>{program.description}</p>
              </div>
              <ul className="program-highlights">
                {program.highlights.map((item) => (
                  <li key={item}>
                    <span className="program-check">
                      <Icon name="check" size={12} />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          ))}

          <div className="programs-cta">
            <h2>Need support right now?</h2>
            <p>Reach out and our team will help you find the right program for your family.</p>
            <div className="programs-cta-actions">
              <Link to="/intake" className="btn">
                Request support <Icon name="arrowRight" size={16} />
              </Link>
              <Link to="/donate" className="programs-btn-ghost">
                Support our work
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
